import React, {useEffect, useState} from 'react';
import {StudentsItems} from "./students-items/Students-items";
import {Pagination} from "components/layout/pagination/Pagination";
import {useAppDispatch, useAppSelector} from "common/hook";
import {useParams} from "react-router-dom";
import {
    fetchLessonsIdStudents
} from "features/model/service/groups/lessons/fetch-lessons-id-students/fetchLessonsIdStudents";
import {Preloader} from "components/layout/preloader/Preloader";
import {NothingYetMessage} from "../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";


export const Students = () => {
    const dispatch = useAppDispatch();
    const {lessonsId} = useParams();
    const studentsState = useAppSelector((state) => state.lessonsStudents);

    const {students, pagination, isLoading, error,groupId} = studentsState;

    const paginationData = useAppSelector((state) => state.lessonsStudents.pagination);

    const {page, pageSize, pageCount} = paginationData;

    const [currentPage, setCurrentPage] = useState(page);
    const totalItems = pageSize * pageCount;


    useEffect(() => {
        dispatch(fetchLessonsIdStudents(lessonsId));
    }, [dispatch, lessonsId]);


    const paginate = (pageNumber: number) => setCurrentPage(pageNumber);


    return (
        <div className="data-tbl lesson-students-tbl no-btn-link-col">
            <div className="row thead">
                <div className="col student-col">Студент</div>
                <div className="col presence-col">Присутствие</div>
                <div className="col homework-col">Домашнее задание</div>
                <div className="col test-amount-col align-right">Тест</div>
            </div>

            {isLoading ? (
                <Preloader />
            ) : (
                students.length > 0 ? (
                    students.map((student, index) => (
                        <StudentsItems key={index} student={student} groupId={groupId} />
                    ))
                ) : (
                    <NothingYetMessage />
                )
            )}


            {page > 0 && (
                <Pagination
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={pageSize}
                    paginate={paginate}
                />
            )}
        </div>
    );
};

